export default function convertToObjects(csvArray, role) {
  let output = []
  if (role === 'Students') {
    csvArray.forEach((row, n) => {
      if (n > 0) {
        const notBlank = row[0] || row[1] || row[2] || row[3] || row[4] || row[5]
        if (row.length > 1 && notBlank) {
          output.push({
            row: n + 1,
            username: row[0],
            email: row[1],
            firstName: row[2],
            lastName: row[3],
            password: row[4],
            sendInvite: row[5].toLowerCase(),
          })
        }
      }
    })
  } else if (role === 'Teachers') {
    csvArray.forEach((row, n) => {
      if (n > 0) {
        const notBlank = row[0] || row[1] || row[2] || row[3] || row[4]
        if (row.length > 1 && notBlank) {
          output.push({
            row: n + 1,
            email: row[0],
            firstName: row[1],
            lastName: row[2],
            password: row[3],
            sendInvite: row[4].toLowerCase(),
          })
        }
      }
    })
  }
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/users/convertToObjects.js